import { NgModule } from '@angular/core';
import { NonMobileFeatureDialogComponent } from './non-mobile-feature-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogModule,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [NonMobileFeatureDialogComponent],
  imports: [
    SharedModule,
    MatDialogModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
  exports: [NonMobileFeatureDialogComponent],
})
export class NonMobileFeatureDialogModule {}
